const pdfReducer = (state: any = { pdfInfo: {}}, action:any) => {
    let {type, payload} = action
    switch (type) {
        case 'SAVE_PDF_URL':
            return state = {
                pdfInfo: payload
            }
        case 'CLEAR_PDF_URL':
            return state = {
                url: '',
                showPDFModal: false
            }
        default:
            return state
    }
}

export default pdfReducer